export const INQUIRY_OPTIONS = [
  { key: 'EXAM_REVIEW_INQUIRY', label: '족보 관련 문의' },
  { key: 'EVENT_INQUIRY', label: '이벤트 관련 문의' },
  { key: 'NOTICE_INQUIRY', label: '공지 관련 문의' },
  { key: 'ETC_INQUIRY', label: '기타' },
];
